import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {BrowserRouter,Routes,Route} from "react-router-dom"
import './index.css'

import Layout from "./pages/Layout"

import App from './pages/App'
import Profile from "./pages/Profile"
import Single from "./pages/Single"
import MyComments from './pages/MyComments'
import NotFound from "./pages/NotFound"

import Provider from './context/FirestoreContext'
import AuthProvider,{useAuthContext} from './context/AuthContext'
function AppRoutes() {
  const { currentUser } = useAuthContext()
  return(
    <Routes>
      <Route path="/" element={<App />}/>
      <Route path="/profile" element={<Profile />}/>
      <Route path="/comments/:id" element={<Single />}/>
      <Route path="*" element={<NotFound />}/>
      {currentUser && <Route path="/mycomments" element={<MyComments/>} />}
    </Routes>
  )
}
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthProvider>
      <Provider>
        <BrowserRouter>
          <Layout>
            <AppRoutes />
          </Layout>
        </BrowserRouter>
      </Provider>
    </AuthProvider>
  </StrictMode>
)